import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { resourceRequest, useResource } from "../../modules/resource/resource";
import * as dialogActions from "../../modules/common/dialog";
import Prepairing from "../common/Prepairing";
// import Link from '../../components/common/Link'

const GroupReservation = () => {
  const GROUP_IMAGE_M = "GROUP_IMAGE_M";
  const GROUP_IMAGE_PC = "GROUP_IMAGE_PC";
  const [imagePc, errorPc] = useResource(GROUP_IMAGE_PC);
  const [imageM, errorM] = useResource(GROUP_IMAGE_M);

  console.log(imagePc, imageM);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resourceRequest(GROUP_IMAGE_PC));
    dispatch(resourceRequest(GROUP_IMAGE_M));
  }, []);

  useEffect(() => {
    if (errorPc && errorPc.message) {
      dispatch(dialogActions.alertOpen(errorPc.message));
    }
    if (errorM && errorM.message) {
      dispatch(dialogActions.alertOpen(errorM.message));
    }
  }, [errorPc, errorM]);

  const isPrePage = process.env.REACT_APP_IS_PREPAIRING_PAGE;

  return (
    <>
      {isPrePage === "Y" && <Prepairing />}

      {isPrePage === "N" && (
        <>
          {/* <div className='img-whole'>
            <img className='pc' src={`${imagePc && imagePc.resource && imagePc.resource.value}`.replace('localhost:8080', 'test.ktwiz.co.kr:17400')} alt="" />
            <img className='m' src={`${imageM && imageM.resource && imageM.resource.value}`.replace('localhost:8080', 'test.ktwiz.co.kr:17400')} alt="" />
          </div>
          <div className='buttons'>
            <Link className='btn btn-red'>단체 관람 신청</Link>
          </div> */}

          <article className="arti g">
            <div className="tit">
              <h6>단체 관람 안내</h6>
            </div>
            <div className="desc">
              <div className="table-responsive" style={{ overflowX: "auto" }}>
                <table className="guide" style={{ width: "100%", textAlign: "center", borderCollapse: "collapse", borderTop: "2px solid #333" }}>
                  <colgroup>
                    <col width="20%" />
                    <col width="50%" />
                    <col width="30%" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th style={{ backgroundColor: "#e2eff9", verticalAlign: "middle", padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>구분</th>
                      <th style={{ backgroundColor: "#e2eff9", verticalAlign: "middle", padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>일반(기업, 동호회 등)</th>
                      <th style={{ backgroundColor: "#e2eff9", verticalAlign: "middle", padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>학교(초/중/고)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th style={{ backgroundColor: "#f9f9f9", verticalAlign: "middle", padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>인원</th>
                      <td style={{ padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>50인 이상 신청 가능</td>
                      <td style={{ padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>20명 이상</td>
                    </tr>
                    <tr>
                      <th style={{ backgroundColor: "#f9f9f9", verticalAlign: "middle", padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>예매 가능일</th>
                      <td colSpan="2" style={{ padding: "10px", border: "1px solid #ccc", textAlign: "center", lineHeight: "1.5" }}>
                        일반 예매 시간과 동일<br />
                        (해당경기 <strong className="red">7일 전 16시</strong>부터 티켓링크 콜센터를 통해 예매 가능)
                      </td>
                    </tr>
                    <tr>
                      <th style={{ backgroundColor: "#f9f9f9", verticalAlign: "middle", padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>취소 가능일</th>
                      <td colSpan="2" style={{ padding: "0", border: "1px solid #ccc" }}>
                        <div style={{ color: "red", fontWeight: "bold", padding: "10px 0", borderBottom: "1px solid #ccc" }}>
                          경기 2일 전까지만 단체관람 취소 가능
                        </div>
                        <div style={{ padding: "10px 0" }}>
                          ※ 예매 당일 취소수수료 미부과, 예매일 이후 취소수수료 10% 부과
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th style={{ backgroundColor: "#f9f9f9", verticalAlign: "middle", padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>증빙 서류</th>
                      <td style={{ textAlign: "left", padding: "10px 20px", border: "1px solid #ccc", lineHeight: "1.5", verticalAlign: "middle" }}>
                        ○ 기업 : 사업자등록증<br />
                        ○ 동호회 : 단체 증빙이 가능한 자료
                      </td>
                      <td style={{ padding: "10px", border: "1px solid #ccc", fontWeight: "bold", verticalAlign: "middle" }}>
                        학교장 날인 공문
                      </td>
                    </tr>
                    <tr>
                      <th style={{ backgroundColor: "#f9f9f9", verticalAlign: "middle", padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>좌석 등급</th>
                      <td colSpan="2" style={{ padding: "10px", border: "1px solid #ccc" }}>
                        응원지정석, 스카이존
                      </td>
                    </tr>
                    <tr>
                      <th style={{ backgroundColor: "#f9f9f9", verticalAlign: "middle", padding: "10px", border: "1px solid #ccc", fontWeight: "bold" }}>할인</th>
                      <td colSpan="2" style={{ padding: "10px", border: "1px solid #ccc", lineHeight: "1.5" }}>
                        장당 2,000원 할인<br />
                        (예매 수수료 장당 1,000원 부과)
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{ marginTop: "15px", fontSize: "14px", lineHeight: "1.6" }}>
                <p>* 단, 현장체험학습 및 수학여행은 학교장 직인이 날인된 공문 제출 시 <span style={{ fontWeight: "bold" }}>경기일 20일 전</span>부터 신청 가능(※<span style={{ fontWeight: "bold" }}>평일 경기에 한함</span>)</p>
                <p>* 관람일 당일 좌석에서 학생 단체에 대한 확인을 진행합니다. 예매 시 전달받은 내용과 실 관람자가 상이할 경우 퇴장 및 예매 취소 처리될 수 있으며, 해당 학교 및 단체는 남은 시즌 단체 관람이 제한됩니다.</p>
                  <p style={{ paddingLeft: "10px" }}>※ 학교 단체는 <span style={{ fontWeight: "bold" }}>학생 비율이 80% 이상</span>이어야 하며 <span style={{ fontWeight: "bold" }}>학생 및 교직원을 제외한 다른 인원이 포함될 수 없습니다.</span> (예: 50명 단체의 경우 40명 이상이 학생 / 가족 등 포함 불가)</p>
                  <p style={{ paddingLeft: "10px" }}>※ 학생 및 교직원은 단체관람 시 신분 확인이 가능한 학생증, 교직원증을 소지해야 합니다.</p>
                <p>* 구단과 제휴된 법인의 경우, 별도 문의 부탁 드립니다.</p>
                <br />
                <p style={{ fontWeight: "bold" }}>[단체관람 신청 안내]</p>
                <p>※ 개막시리즈(4/3~5), 어린이날(5/5), 워터페스티벌, 빅또리데이 등 특정 경기에는 단체 관람 예매가 불가능합니다.</p>
                <p>※ 구단 이벤트 등으로 신청이 불가한 좌석이 생길 수 있습니다.</p>
                <p>※ 단체관람 결제 완료 후에는 자리 변경, 교환은 불가합니다.</p>
              </div>
            </div>
            <div className="imgs-wrap">
              <div className="item">
                <img
                  className="pc"
                  src={require("../../assets/img/ticket/group_guide_img_1.png")}
                  alt=""
                />
                <img
                  className="m"
                  src={require("../../assets/img/ticket/group_guide_img_1_m.png")}
                  alt=""
                />
              </div>
              <div className="item">
                <img
                  className="pc"
                  src={require("../../assets/img/ticket/group_guide_img_2.png")}
                  alt=""
                />
                <img
                  className="m"
                  src={require("../../assets/img/ticket/group_guide_img_2_m.png")}
                  alt=""
                />
              </div>
              <div className="item">
                <img
                  className="pc"
                  src={require("../../assets/img/ticket/group_guide_img_3.png")}
                  alt=""
                />
                <img
                  className="m"
                  src={require("../../assets/img/ticket/group_guide_img_3_m.png")}
                  alt=""
                />
              </div>
            </div>
          </article>
          {/* <article className='arti'>
            <div className='tit'>
              <h6>유의사항</h6>
            </div>
            <div className='desc'>
              <div className='notice'>
                <div className='r'>
                  <span className='mark'>-</span>
                  <span className='txt'>
                    단체관람 신청은 경기 1일 전까지 가능하며, 경기 14일 전까지 신청하셔야 원하시는 자리를 확보하실 수 있습니다.
                                    </span>
                </div>
                <div className='r'>
                  <span className='mark'>-</span>
                  <span className='txt'>
                    결제와 동시에 발권이 진행되며, 발권이 완료된 입장권의 취소 시에는 소정의 취소수수료가 발생합니다.
                                    </span>
                </div>
                <div className='r in'>
                  <span className='mark'>*</span>
                  <span className='txt'>
                    예매 당일 : 취소수수료 없음, 예매일 이후 경기일 1일전 : 결제금액의 10% 수수료 발생
                                    </span>
                </div>
                <div className='r'>
                  <span className='mark'>-</span>
                  <span className='txt'>
                    경기일 당일에는 환불 및 취소가 절대 불가능하오니 유의하시기 바랍니다.
                                    </span>
                </div>
                <div className='r'>
                  <span className='mark'>-</span>
                  <span className='txt'>
                    우천취소 시 신용카드는 자동 취소되며 무통장입금은 신청 시 기재해주신 환불계좌를 통해 7일내 입금이 됩니다.
                                    </span>
                </div>
                <div className='r'>
                  <span className='mark'>-</span>
                  <span className='txt'>
                    단체관람 할인은 20인이상 단체관람에 한해 2,000원 할인 적용됩니다.
                                    </span>
                </div>
                <div className='r'>
                  <span className='mark'>-</span>
                  <span className='txt'>
                    반입물품 안내 사항은 아래와 같습니다.
                                    </span>
                </div>
                <div className='r in'>
                  <span className='mark'>1)</span>
                  <span className='txt'>
                    반입금지물품 : 주류(5% 이상)및 병, 캔 음료, 가스버너, 아이스박스, 유모차
                                    </span>
                </div>
                <div className='r in'>
                  <span className='mark'>2)</span>
                  <span className='txt'>
                    현수막, 엠프, 대북, 꾕과리, 호루라기, 부부젤라 등 경기에 방해되는 안내물 및 응원도구
                                    </span>
                </div>
                <div className='r'>
                  <span className='mark'>-</span>
                  <span className='txt'>
                    월요일은 구단 휴무일로 전화상담이 불가능 합니다.
                                    </span>
                </div>
              </div>
            </div>
          </article> */}
          {/* <article className='arti'>
            <div className='tit'>
              <h6>전화문의 시간 안내</h6>

            </div>
            <div className='desc'>
              <div className='guide-wrap'>
                <div className='item'>
                  <div className='icon icon-phone'></div>
                  <h6>전화번호</h6>
                  <div className='row'>
                    <div className='mark'>·</div>
                    <div className='con'>1899-5916</div>
                  </div>
                  {/* <div className='row'>
                <div className='mark'>·</div>
                <div className='con'>010-1234-1234</div>
              </div>
                </div>
                <div className='item'>
                  <div className='icon icon-clock'></div>
                  <h6>운영시간</h6>
                  <div className='row'>
                    <div className='mark'>·</div>
                    <div className='con'>홈경기일(평일/주말) : 경기 시작 3시간 전 ~ 경기 시작 후 7회 말까지</div>
                  </div>
                  <div className='row'>
                    <div className='mark'>·</div>
                    <div className='con'>홈경기 없는 날(평일) : 오전 10시 ~ 17시</div>
                  </div>
                  <div className='row'>
                    <div className='mark'>※</div>
                    <div className='con'>&nbsp;월요일/주말 홈경기 없는 날/공휴일 미운영</div>
                  </div>
                  <div className='row'>
                    <div className='con'>(점심시간 : 12시~13시)</div>
                  </div>
                </div>
                <div className='item'>
                  <div className='icon icon-ball'></div>
                  <h6>휴일</h6>
                  <div className='row'>
                    <div className='mark'>·</div>
                    <div className='con'>주말 홈경기 있을 시 : 월요일</div>
                  </div>
                  <div className='row'>
                    <div className='mark'>·</div>
                    <div className='con'>주말 홈경기 없을 시 : 토, 일, 월</div>
                  </div>
                </div>
              </div>
            </div>
          </article> */}
        </>
      )}
    </>
  );
};

export default GroupReservation;
